import { FC, useCallback, useState } from "react";
import { createContext } from "use-context-selector";

export type ExternalContextType = {
  homePage: boolean;
  setHomePage: (value: boolean) => void;
};

export const ExternalContext = createContext({} as ExternalContextType);

export const ExternalContextProvider = ({ children }: { children: any }) => {
  const [homePage, setHomePageState] = useState<boolean>(true);
  const setHomePage = useCallback((value: boolean) => {
    setHomePageState(value);
  }, []);

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <ExternalContext.Provider value={{ homePage, setHomePage }}>
      {children}
    </ExternalContext.Provider>
  );
};
